import * as React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { currentLanguage } from "../../translations/CurrentLanguage";
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const PAGE = 20;

const Chip = ({ label, count, icon, selected, disabled, onPress }) => (
  <TouchableOpacity
    activeOpacity={0.8}
    disabled={disabled}
    onPress={onPress}
    style={[
      styles.chip,
      selected ? styles.chipSelected : null,
      disabled ? styles.chipDisabled : null,
    ]}
  >
    {icon ? (
      <Icon
        name={icon}
        size={13}
        color={selected ? "#fff" : colors.warning}
        style={styles.chipIcon}
      />
    ) : null}
    <Text style={[styles.label, selected ? styles.labelSelected : null]}>
      {label}
    </Text>
    {count !== undefined ? (
      <View style={[styles.count, selected ? styles.countSelected : null]}>
        <Text
          style={[styles.countText, selected ? styles.labelSelected : null]}
        >
          {count}
        </Text>
      </View>
    ) : null}
  </TouchableOpacity>
);

export default class CategoriesComponent extends React.PureComponent {
  componentDidMount() {
    this.loadMore();
  }

  componentDidUpdate() {
    this.loadMore();
  }

  // categories are read from the database one page at a time
  loadMore() {
    const length = this.props.data ? this.props.data.length : 0;
    if (length > 0 && length % PAGE === 0 && this.requested !== length) {
      this.requested = length;
      this.props.onEndReached();
    }
  }

  countOf(category) {
    const match = this.props.catLengths.find(
      result => result.categoryId === category._id,
    );
    return match ? match.categoryLength : 0;
  }

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);
    const { selectedCategoryIndex, disabled, onCategoryClick } = this.props;

    return (
      <View style={styles.container}>
        <Chip
          icon="star"
          label={strings.Favorites}
          selected={selectedCategoryIndex === -2}
          onPress={() => onCategoryClick("", -2)}
        />
        <Chip
          label={strings.All}
          count={this.props.itemsLength}
          selected={selectedCategoryIndex === -1}
          onPress={() => onCategoryClick("", -1)}
        />
        {this.props.data.map((category, index) => (
          <Chip
            key={category._id}
            label={category.name}
            count={this.countOf(category)}
            disabled={disabled}
            selected={selectedCategoryIndex === index}
            onPress={() => onCategoryClick(category._id, index)}
          />
        ))}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 4,
  },
  chip: {
    flexDirection: "row",
    alignItems: "center",
    height: 38,
    paddingHorizontal: 14,
    marginRight: 8,
    marginBottom: 8,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
  },
  chipSelected: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
  },
  chipDisabled: {
    opacity: 0.5,
  },
  chipIcon: {
    marginRight: 6,
  },
  label: {
    fontSize: 14,
    fontWeight: "600",
    color: "#334155",
  },
  labelSelected: {
    color: "#fff",
  },
  count: {
    marginLeft: 8,
    minWidth: 22,
    height: 20,
    paddingHorizontal: 6,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eef2f7",
  },
  countSelected: {
    backgroundColor: "rgba(255, 255, 255, 0.22)",
  },
  countText: {
    fontSize: 12,
    fontWeight: "700",
    color: colors.textMuted,
  },
});
